// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get list menu package GET /api/v1/menu-package */
export async function menuPackageList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.menuPackageListParams,
  options?: { [key: string]: any },
) {
  return request<API.MenuPackageListDto>('/api/v1/menu-package', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Create menu package POST /api/v1/menu-package */
export async function menuPackageAdd(
  body: API.CreateMenuPackageParamDto,
  options?: { [key: string]: any },
) {
  return request<API.MenuPackage>('/api/v1/menu-package', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Get menu package detail GET /api/v1/menu-package/${param0} */
export async function menuPackageDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.menuPackageDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.MenuPackage>(`/api/v1/menu-package/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Update menu package PUT /api/v1/menu-package/${param0} */
export async function menuPackageUpdate(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.menuPackageUpdateParams,
  body: API.UpdateMenuPackageParamDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.MenuPackage>(`/api/v1/menu-package/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Delete menu package DELETE /api/v1/menu-package/${param0} */
export async function menuPackageDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.menuPackageDeleteParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/menu-package/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Change menu package status PATCH /api/v1/menu-package/status */
export async function menuPackageChangeStatus(
  body: API.ChangeManyStatusParamDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/menu-package/status', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
